export const MAX_MANUAL_ENTRIES = 20;

export const MANUAL_ENTRY_CHANNELS = {
  MPESA: "Mpesa",
  BANK: "Bank",
};

export const MANUAL_ENTRY_CHANNEL_OPTIONS = [
  { value: MANUAL_ENTRY_CHANNELS.MPESA, label: "M-Pesa" },
  { value: MANUAL_ENTRY_CHANNELS.BANK, label: "Bank" },
];

export const BANK_MIN_AMOUNT = 10;
